/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_UsageInputs */

const en_admin_resources_usage = /** @type {(inputs: Admin_Resources_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage`)
};

const de_admin_resources_usage = /** @type {(inputs: Admin_Resources_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwendung`)
};

const es_admin_resources_usage = /** @type {(inputs: Admin_Resources_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso`)
};

const fr_admin_resources_usage = /** @type {(inputs: Admin_Resources_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisation`)
};

/** @type {(inputs: Admin_Resources_UsageInputs) => LocalizedString} */
const it_admin_resources_usage = en_admin_resources_usage;

/** @type {(inputs: Admin_Resources_UsageInputs) => LocalizedString} */
const pt_br2_admin_resources_usage = en_admin_resources_usage;

/** @type {(inputs: Admin_Resources_UsageInputs) => LocalizedString} */
const pl_admin_resources_usage = en_admin_resources_usage;

/** @type {(inputs: Admin_Resources_UsageInputs) => LocalizedString} */
const hu_admin_resources_usage = en_admin_resources_usage;

/** @type {(inputs: Admin_Resources_UsageInputs) => LocalizedString} */
const ro_admin_resources_usage = en_admin_resources_usage;

/**
* | output |
* | --- |
* | "Usage" |
*
* @param {Admin_Resources_UsageInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_usage = /** @type {((inputs?: Admin_Resources_UsageInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_UsageInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_usage(inputs)
	if (locale === "de") return de_admin_resources_usage(inputs)
	if (locale === "es") return es_admin_resources_usage(inputs)
	if (locale === "fr") return fr_admin_resources_usage(inputs)
	if (locale === "it") return it_admin_resources_usage(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_usage(inputs)
	if (locale === "pl") return pl_admin_resources_usage(inputs)
	if (locale === "hu") return hu_admin_resources_usage(inputs)
	return ro_admin_resources_usage(inputs)
});
export { admin_resources_usage as "admin.resources.usage" }